import { auth } from "../firebase";
import { CreatePost } from "../types";
import http from "@/common/axios";
import { captureException } from "@sentry/react";
import BunnyNet from "./bunnynet";

interface UploadResponse {
  status: string;
  message: string;
  reviewId: number;
}

export async function uploadVideo(
  { video, title, caption, rating }: CreatePost,
  onProgress?: (percent: number) => void,
) {
  const user = auth.currentUser;
  if (!user) {
    throw new Error("User not logged");
  }

  const placeRef = window.localStorage.getItem("placeRef");

  if (!placeRef) {
    captureException(new Error("Place Ref not present"));
    throw new Error("Place Ref not present");
  }

  const guid = await BunnyNet.createVideo(placeRef);
  await BunnyNet.uploadVideo(guid, video, onProgress);
  try {
    const { data } = await http.put<UploadResponse>("/reviews/upload", {
      title,
      caption,
      restaurant_id: parseInt(placeRef),
      bunnynet_video_id: guid,
      rating: {
        overall: rating,
      },
    });

    // Attribute review to waiter if present (fire-and-forget)
    const waiterRef = sessionStorage.getItem("waiterRef");
    if (waiterRef && data?.reviewId) {
      const waiterId = parseInt(waiterRef, 10);
      if (!isNaN(waiterId)) {
        http
          .post(`/waiters/${waiterId}/attribute-review`, {
            review_id: data.reviewId,
          })
          .catch(() => {
            // Silent — attribution failure must not affect user flow
          });
      }
      sessionStorage.removeItem("waiterRef");
    }
  } catch (error) {
    await BunnyNet.deleteVideo(guid);
    captureException(error);
    throw error;
  }
}
